<template>
  <div class="page">
    <div class="srcoll">
      <section class="section" style="padding-top: 0;">
        <div class="z-title">标题</div>
        <div class="content">
          <a-input v-model="form.title"></a-input>
        </div>
      </section>

      <section class="section">
        <section class="z-item" style="margin-bottom: 10px;">
          <div class="z-title">内容<span>*</span></div>
          <div class="input">
            <a-textarea
              placeholder="填写任务内容"
              v-model="form.record_text"
              :rows="4"
              :maxLength="3000"
              style="border: none;"
            />
            <div class="number">{{ form.record_text.length }}/3000</div>
          </div>

          <div class="upload">
            <a-upload
              :style="{ width: fileList.length ? '100%' : '120px' }"
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :fileList="fileList"
              :remove="handleRemove"
              :show-upload-list="true"
              before-upload="beforeUpload"
              @preview="handlePreview"
              :action="directorTestApi.main + directorTestApi.upload"
              accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic, video/*"
              multiple
              @change="
                (info) => {
                  fileList = info.fileList.map((file) => {
                    if (!file.thumbUrl && file.status == 'done') {
                      file.thumbUrl =
                        file.type.indexOf('audio') > -1
                          ? require('../../../assets/director/record.png')
                          : require('@/assets/director/video.png');
                    }
                    return file;
                  });
                }
              "
            >
              <div>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  点击上传照片/视频
                </div>
              </div>
            </a-upload>
            <a-upload
              name="avatar"
              :style="{ width: fileList2.length ? '100%' : '120px' }"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="true"
              :remove="handleRemove"
              :action="directorTestApi.main + directorTestApi.upload"
              accept="audio/*"
              multiple
              :fileList="fileList2"
              @preview="handlePreview"
              @change="
                (info) => {
                  fileList2 = info.fileList.map((file) => {
                    if (!file.thumbUrl && file.status == 'done') {
                      file.thumbUrl =
                        file.type.indexOf('audio') > -1
                          ? require('../../../assets/director/record.png')
                          : require('@/assets/director/video.png');
                    }
                    return file;
                  });
                }
              "
            >
              <div>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  点击上传音频
                </div>
              </div>
            </a-upload>
          </div>
          <div class="upload-tip">
            单个图片/视频不能超过500M;上传上限100张图片
          </div>
        </section>
      </section>

      <section class="section">
        <div class="z-title">发送时间 <span>*</span></div>
        <div class="content">
          <a-date-picker
            show-time
            v-model="form.record_time"
          />
        </div>
      </section>
    </div>

    <a-modal
      :visible="previewModal"
      @cancel="previewModal = false"
      centered
      title="预览"
      :footer="false"
      :closeable="false"
      :bodyStyle="{ padding: '20px 20px' }"
    >
      <div class="preview-body">
        <img
          style="width: 100%;height: auto"
          v-if="previewUrl.type == 'pic'"
          :src="previewUrl.url"
        />
        <video
          v-if="previewUrl.type == 'video'"
          style="width: 100%;height: 300px;object-fit: fill;"
          :src="previewUrl.url"
          controls
        ></video>
        <audio
          style="width: 100%;object-fit: fill;"
          v-if="previewUrl.type == 'record'"
          :src="previewUrl.url"
          controls
        ></audio>
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import beaList from "../../bea-list-add.vue";
import { mapActions } from "vuex";
import qs from "qs";
import _ from "lodash";
import addLevel from "../../../pages/observe/add-level.vue";
import { directorTestApi } from "../../../api/api-director";
import { mapState } from "vuex";
import { checkFileFormat } from "../../../utils/validate";
import moment from "moment";

export default {
  data() {
    return {
      previewUrl: "",
      previewModal: false,
      saveTime: "",
      data: null,
      directorTestApi,
      checkAll: false,
      showPlate: false,
      selectBeaForm: null,
      strategy_att2: [],
      record_att: [
        {
          record_text: "",
          fileList: [],
          fileList2: [],
        },
      ],
      form: {
        data_type: "official",
        id: "",
        record_text: "",
        title: "",
        task_id: "",
        record_time: "",
        record_att: "",
        privilege: "",
      },
      students: [],
      selectType: 1,
      loading: false,
      fileList: [],
      fileList2: [],
      studentList: [],
      active: 0,
      activityCheckedList: [],
      SelectBea: null,
      customStyle:
        "background: #fff;border-radius: 4px;border: 0;overflow: hidden;font-weight:bold",
      activeKey: 0,
      showClDetail: false,
      clList: [],
      openBea: false,
      beaSelect: null,
      beas: [],
      targets: [],
      showRange: false,
      rangeCheckedList: [],
    };
  },
  props: {
    id: {
      type: String | Number,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    beaList,
    addLevel,
  },
  computed: {
    ...mapState(["currentClass", "userInfo"]),
    formContent() {
      if (
        this.form.start_time &&
        this.form.record_text &&
        this.form.end_time &&
        this.students &&
        this.students.length
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    showAddStudents(val) {
      if (val) {
        const students = this.students.map((item) => {
          return item.id;
        });
        this.studentList.forEach((group, index) => {
          group.student.forEach((item) => {
            if (students.includes(item.id)) {
              item.checked = true;
            }
          });
        });
      }
    },
    show(val) {
      if (val) {
        this.getDetail(this.id);
      }
    },
    userInfo() {
      if (this.userInfo) {
        if (this.currentClass) {
          this.getAllStudents();
        } else {
          this.getClassList();
        }

        this.getDetail(this.id);
      }
    },
  },
  created() {
    this.form.id = this.id;
    if (this.userInfo) {
      this.getDetail(this.id);
    }

    if (this.userInfo) {
      if (this.currentClass) {
        this.getAllStudents();
      } else {
        this.getClassList();
      }
    }
  },
  methods: {
    beforeUpload(file) {
      const { valid, message } = checkFileFormat(file);
      if (!valid) {
        this.$message.warning(message);
        return false;
      }
      return true;
    },
    handlePreview(e) {
      this.previewUrl = {
        url: e.response.data.url,
        type: this.getFileType(e.response.data.url),
      };
      this.previewModal = true;
    },
    getDetail(id) {
      this.$message.loading({
        content: "正在获取详情...",
        key: "loading",
      });
      axios({
        url: directorTestApi.main + directorTestApi.getTeacherObserCircleDetail,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        method: "POST",
        data: qs.stringify({
          id,
          teacher_id: this.userInfo.id,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "获取成功",
            key: "loading",
            duration: 0.5,
          });
          const data = res.data.data;
          this.data = res.data.data;
          this.saveTime = data.addTime;
          this.form = {
            id: data.id,
            record_text: data.record_text,
            title: data.title,
            task_id: data.task_id,
            record_time: data.record_time,
            record_att: data.record_att,
            privilege: data.privilege,
          };
          this.students = data.students;
          this.range = data.fields.map((item) => item.target_name);
          this.beas = data.target2;
          this.showModal = true;
          this.fileList = data.att
            .filter((item) => item.type != "record")
            .map((item, index) => {
              item.response = { data: _.cloneDeep(item) };
              item.thumbUrl =
                item.type == "video"
                  ? require("../../../assets/director/video.png")
                  : item.url;
              item.status = "done";
              item.uid = item.id;
              item.name = "record" + index;
              item.response.data.id = item.accessory_id;
              return item;
            });
          this.fileList2 = data.att
            .filter((item) => item.type == "record")
            .map((item, index) => {
              item.thumbUrl = require("../../../assets/director/record.png");
              item.status = "done";
              item.response = { data: _.cloneDeep(item) };
              item.uid = item.id;
              item.name = "audio" + index;
              item.response.data.id = item.accessory_id;
              return item;
            });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleRemove() {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: "提示",
          content: "确定要删除吗？",
          centered: true,
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          },
        });
      });
    },
    handleDelSelef(type, id) {
      axios({
        url:
          type == "scene"
            ? directorTestApi.main + directorTestApi.saveDeleteObserSelfScene
            : directorTestApi.main + directorTestApi.saveDeleteObserSelfAct,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          teacher_id: this.userInfo.id,
          id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "删除成功",
          });
          if (type == "scene") {
            this.getSelefScenes();
          } else {
            this.getSelefActs();
          }
        } else {
          this.$message.error({ content: res.data.message });
        }
      });
    },
    handleDelStudent(index) {
      if (this.students[index].name == "全部") {
        this.checkAll = false;
        this.studentList.forEach((element, index) => {
          element.student.forEach((el) => {
            el.checked = false;
          });
        });
        this.students.splice(index, 1);
      } else {
        this.students.splice(index, 1);
        this.checkAll = false;
      }
    },
    handleAddSelef(type) {
      this.selefType = type;
      this.showSelef = true;
    },
    handleAddSelefOk() {
      this.$message.loading({
        content: "正在添加...",
        key: "addSelef",
      });
      axios({
        url:
          this.selefType == "scene"
            ? directorTestApi.main + directorTestApi.saveObserSelfScene
            : directorTestApi.main + directorTestApi.saveObserSelfAct,
        method: "post",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          teacher_id: this.userInfo.id,
          name: this.selef_name,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "添加成功",
            key: "addSelef",
          });
          this.selefType == "scene"
            ? this.getSelefScenes()
            : this.getSelefActs();
          this.showSelef = false;
          this.selef_name = "";
        } else {
          this.$message.error({ content: res.data.message, key: "addSelef" });
        }
      });
    },
    handleChangeSelectChild(child) {
      child.checked = !child.checked;
      if (!child.checked) {
        this.checkAll = false;
      }
      this.$forceUpdate();
    },
    getSceneList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserSceneList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        this.cjList = res.data.data;
      });
    },
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 100,
        teacher_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.userInfo.school_id || "",
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.allClassList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        this.classList = res.data.data;
        this.className = this.classList[0].class_name;
        this.$store.state.currentClass = this.classList[0];
        this.getAllStudents();
      });
    },
    getAllStudents() {
      this.studentListForm = {
        class_id: this.currentClass.id,
        currentPage: 1,
        name: "",
        pageSize: 100,
        teacher_id: this.userInfo.id,
        school_id: this.userInfo.school_id || "",
      };

      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getGroupStudentList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.studentListForm,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        this.studentList = [
          {
            label: "A",
            childs: res.data.data,
          },
        ];
        this.studentList = res.data.data;
      });
    },
    handleChangeBea(e, item) {
      this.selectBeaForm = {
        range: item.name,
      };
    },
    handleAddBea() {
      if (!this.selectBeaForm || !this.selectBeaForm.detail) {
        this.$message.error("请选择目标");
        return;
      }
      if (this.checkAll) {
        this.selectBeaForm.students = this.studentList
          .map((item) => item.student)
          .flat()
          .filter((item) => item.checked);
      } else {
        this.selectBeaForm.students = this.students;
      }

      this.selectBeaForm.students.map((item) => {
        item.bea = _.cloneDeep(this.selectBeaForm.detail);
        return item;
      });
      this.openBea = true;
      this.showBea = false;
    },
    onChange(e) {
      console.log(e);
      this.checkedList = e;
    },
    handleAddRange() {
      console.log(this.rangeCheckedList);
      this.range = this.rangeCheckedList.flat();
      this.showRange = false;
    },
    SectionToChinese(section) {
      var chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      var chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
      var strIns = "",
        chnStr = "";
      var unitPos = 0;
      var zero = true;
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },
    //策略家庭确认选择
    handlePush() {
      if (this.saving) {
        this.$message.error("正在保存，请稍后再试");
        return;
      }
      this.form.teacher_id = this.userInfo.id
      this.form.record_att = JSON.stringify([
                  ...this.fileList.map((item) => {
                    return {
                      accessory_id: item.response.data.id,
                      content: "",
                    };
                  }),
                  ...this.fileList2.map((item) => {
                    return {
                      accessory_id: item.response.data.id,
                      content: "",
                    };
                  }),
                ])
        axios({
          method: "post",
          url: directorTestApi.main + directorTestApi.saveTeacherEditObserCircle,
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: this.$store.state.headers,
          },
          data: qs.stringify(this.form),
        }).then((res) => {
          if (res.data.code == 1) {
            this.$message.success({
              content: '修改成功',
              key: "submit",
            });

              setTimeout(() => {
                this.$emit("close", true);
              }, 800);
            setTimeout(() => {
              this.saving = false;
            }, 500);
          } else {
            this.$message.error({
              content: res.data.message,
              key: "submit",
            });
          }
        });
    },
    handleUploadChange(info, key) {
      console.log(info);
      this[key] = info.fileList.map((item) => {
        if (!item.thumbUrl && item.status == "done") {
          item.thumbUrl =
            item.type.indexOf("audio") > -1
              ? require("../../../assets/director/record.png")
              : require("../../../assets/director/video.png");
        }
        return item;
      });
      console.log(this[key]);
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-checkbox-group {
  width: 100%;
}
section.section {
  border-bottom: 1px solid #ececec;
  padding: 20px 2px;

  .z-title {
    position: relative;
    padding-left: 10px;
    line-height: 1.2;
    font-size: 14px;
    color: #555;
    font-weight: bold;
    &::before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 3px;
      background: #73b5de;
      height: 100%;
    }
    span {
      color: red;
      margin-left: 1px;
    }
    span.tip {
      color: #999;
      font-weight: 400;
      margin-left: 5px;
    }
  }

  .input {
    margin-top: 10px;
    position: relative;
    .number {
      position: absolute;
      right: 12px;
      bottom: 3px;
      font-size: 12px;
      color: #7a7a7a;
    }
  }

  .upload {
    margin-top: 10px;
    span {
      display: inline-block;
    }
  }
  .upload-tip {
    font-size: 12px;
    color: #999;
    width: 100%;
  }

  .content {
    margin-top: 20px;
  }
}

.range {
  margin: 10px 0;
  .Up {
    font-weight: 800;
    margin-bottom: 5px;
    font-size: 14px;
  }
}

.page {
  height: 100%;
  max-width: 900px;
  position: relative;
  margin: 0 auto;
  .router {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    flex-direction: row;
    padding: 0 0px;
    color: #999;
    .back {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-direction: row;
      .name {
        margin-left: 5px;
        color: #999;
      }
    }
  }

  .srcoll {
    height: calc(100% - 75px);
    // overflow-y: scroll;
    padding: 5px 0px;
    background: #fff;
    border-radius: 5px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }
  }
}

.drawer-select {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    width: 100%;
  }
}
.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    padding: 20px;
    .plate {
      margin-top: 20px;
      user-select: none;
      .item {
        font-size: 12px;
        width: 120px;
        height: 155px;
        border-radius: 5px;
        cursor: pointer;
        padding: 10px;
        margin-right: 10px;
        color: #555;
        position: relative;
        font-size: 14px;
        box-shadow: 2px 3px 6px 3px rgba($color: #0e6dc5, $alpha: 0.2);
        &::after {
          content: "";
          position: absolute;
          left: 10px;
          top: 50px;
          height: 5px;
          border-radius: 5px;
          width: 40px;
          background: #90bce6;
        }

        &::before {
          content: "";
          position: absolute;
          left: 10px;
          top: 60px;
          height: 5px;
          border-radius: 5px;
          width: 55px;
          background: #90bce6;
        }
      }
    }
  }
}

.selectCl {
  border: 1px solid #92b8cf !important;
  color: #fff !important;
  background: #7da2b9 !important;
  padding: 4px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 10px;
}

.bea {
  margin-top: 10px;
  .mb {
    color: #598ebe;
    font-weight: bold;
    margin: 5px 0;
  }
  .students {
    margin: 10px 0;
  }
  .bea-list {
    width: 100%;
    .cell {
      padding: 5px 10px;
      border-radius: 20px;
      border: 1px solid #eee;
      margin: 8px 0;
      box-shadow: 0 0 2px 1px rgba($color: #000000, $alpha: 0.06);
    }
  }
}

.hr {
  height: 6px;
  background: #eee;
}

.cl-card {
  width: 100%;
  box-shadow: 0 0 3px 2px rgba($color: #000000, $alpha: 0.08);
  padding: 10px;
  border-radius: 8px;
  .item {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .foot {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0;
    font-size: 12px;

    .select {
      color: #999;
      margin-right: auto;
    }
  }
}

.clDetail {
  width: 100%;
  padding: 15px;
  .cl-title {
    font-size: 14px;
    font-weight: bold;
  }

  .cl-list {
    margin: 10px 0;
  }
}

.select-this {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    //倒三角
    width: 0;
    z-index: 20;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #90bce6 transparent;
    left: 42%;
    top: 24px;
  }
}
</style>
